import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
export default function (Bar) {
  var FixedLength =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(FixedLength, _PureComponent);

    var _super = _createSuper2(FixedLength);

    function FixedLength() {
      _classCallCheck(this, FixedLength);

      return _super.apply(this, arguments);
    }

    _createClass(FixedLength, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            length = _this$props.length,
            scrollLength = _this$props.scrollLength;
        var barLength = length / scrollLength * length;
        if (barLength < 20) barLength = 20;
        return (
          /*#__PURE__*/
          React.createElement(Bar, Object.assign({}, this.props, {
            length: length,
            barLength: barLength
          }))
        );
      }
    }]);

    return FixedLength;
  }(PureComponent);

  return FixedLength;
}